import React, { useEffect, useRef, useState } from 'react';
import { View, Text, TextInput, Animated, Easing, SafeAreaView, ScrollView } from 'react-native';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import FadeTransition from '../../components/fadeTransition';
import { CROSS, MINUS, PLUS } from '../../assets';
import { getCleanUrl } from '../../utils/Helper';
import { useSelector } from 'react-redux';


const ItemInfo = ({ selectedStoreItem, handleAddToCart, handleRemoveFromCart, handleCloseItemsInfo }) => {


  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;
  
  const imageUri = selectedStoreItem.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || selectedStoreItem.storeItemImages?.[0]?.imagePath;

  const [quantity, setQuantity] = useState(1);

  const incrementQuantity = () => setQuantity(prev => prev + 1);
  const decrementQuantity = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));


  const handleClickAddToBag = () => {
    handleAddToCart({ ...selectedStoreItem, quantity: quantity })

    if (!selectedStoreItem.hasItemAddOns) {
      handleCloseItemsInfo();
    }
  }


  return (


    <View style={getStyles(['customModalContainer'])} id='customModalContainer'>
      <FadeTransition duration={300}>
        <View style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)" }}></View>

        <View style={getStyles(['customModalInnerContainer'])} id='customModalInnerContainer'>


          <View style={getStyles(['hcommerce_iteminfo_container'])} id='hcommerce_iteminfo_container'>

            <SafeAreaView style={getStyles(['crossOverContainer_Container'])} id='crossOverContainer_Container'>
              <CustomPressable style={getStyles(['crossOverContaniner_Cross'])} onPress={handleCloseItemsInfo} id='crossOverContaniner_Cross'>
                <ImageComp source={CROSS} />
              </CustomPressable>
            </SafeAreaView>

            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['hcommerce_iteminfo_mainContainer'])} id='hcommerce_iteminfo_mainContainer'>


              <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_iteminfo_HeaderContainer'])} id='hcommerce_iteminfo_HeaderContainer'>
                {
                  imageUri &&
                  <ImageComp source={getCleanUrl(imageUri)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_iteminfo_HeaderImg', { height: 300 }])} id='widgetmainContainerHeaderImg hcommerce_iteminfo_HeaderImg' />
                }

                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_iteminfo_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer hcommerce_iteminfo_HeaderTitleContainer'>
                  <View>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_iteminfo_HeaderTitle'])} id='widgetmainContainerHeaderTitle hcommerce_iteminfo_HeaderTitle'>{selectedStoreItem.itemName}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_iteminfo_HeaderSubTitle'])} id='widgetmainContainerHeaderSubTitle hcommerce_iteminfo_HeaderSubTitle'>{selectedStoreItem.itemDescription}</Text>
                  </View>

                  <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_iteminfo_HeaderSubTitle'])} id='widgetmainContainerHeaderSubTitle hcommerce_iteminfo_HeaderSubTitle'>{currencyCode}{selectedStoreItem.itemPrice}</Text>
                </View>
              </View>

              <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerce_iteminfo_MainContainerChildContainer'])} id='widgetmainContainerChildContainer hcommerce_iteminfo_MainContainerChildContainer'>

                {!selectedStoreItem.hasItemAddOns &&
                  <View style={getStyles(['hcommerce_iteminfo_MainContainerChildContainer_amount_container'])} id='hcommerce_iteminfo_MainContainerChildContainer_amount_container'>

                    <Text style={getStyles(['hcommerce_iteminfo_MainContainerChildContainer_amount_container_text'])} id='hcommerce_iteminfo_MainContainerChildContainer_amount_container_text'>Quantity</Text>

                    <View style={getStyles(['additem_controls2'])} id='additem_controls2'>
                      <CustomPressable disabled={quantity <= 1} onPress={decrementQuantity} style={getStyles(['additem_controls_sub_container2'])} id='additem_controls_sub_container2'>
                        <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2' />
                      </CustomPressable>
                      <Text style={getStyles(['additem_controls_qty_text2'])} id='additem_controls_qty_text2'>{quantity}</Text>
                      <CustomPressable onPress={incrementQuantity} style={getStyles(['additem_controls_sub_container2'])} id='additem_controls_sub_container2'>
                        <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2'/>
                      </CustomPressable>

                    </View>
                  </View>
                }

                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleClickAddToBag} id='primaryBtn'>
                  <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('h-commerce.add_to_myOrder')}</Text>
                </CustomPressable>

              </View>

            </ScrollView>
          </View>
        </View>
      </FadeTransition>
    </View>
  );
};


export default ItemInfo;
